import {useNavigate} from "react-router-dom";
import BrandLogo from "../../components/BrandLogo/BrandLogo";

const NotFound = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("user"));
    const userType = user?.userType;
    const handleRedirect = () => {
        if (userType === "Internal") {
            navigate("/admin/dashboard", {replace: true});
        } else {
            navigate("/dashboard", {replace: true});
        }
    };

    return (
        <div
            style={{
                width: "100%",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f9fafb",
                fontFamily: "Inter, sans-serif",
                padding: "40px 20px",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Background Circle 1 */}
            <div
                style={{
                    position: "absolute",
                    width: "400px",
                    height: "400px",
                    background: "#e0e7ff",
                    borderRadius: "50%",
                    top: "-100px",
                    right: "-100px",
                }}
            />

            {/* Background Circle 2 */}
            <div
                style={{
                    position: "absolute",
                    width: "300px",
                    height: "300px",
                    background: "#dbeafe",
                    borderRadius: "50%",
                    bottom: "-120px",
                    left: "-120px",
                }}
            />

            {/* Main Content */}
            <div
                style={{
                    maxWidth: "1100px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* Left Section */}
                <div style={{flex: "1", minWidth: "300px"}}>
                    <h1
                        style={{
                            fontSize: "90px",
                            margin: "0",
                            color: "#2563eb",
                            fontWeight: "800",
                        }}
                    >
                        404
                    </h1>

                    <h2
                        style={{
                            fontSize: "36px",
                            margin: "10px 0",
                            color: "#111827",
                        }}
                    >
                        Oops! Page not found.
                    </h2>

                    <p
                        style={{
                            fontSize: "16px",
                            color: "#6b7280",
                            maxWidth: "450px",
                            marginBottom: "30px",
                            lineHeight: "1.6",
                        }}
                    >
                        The page you’re looking for doesn’t exist or you may not
                        have permission to access it.
                    </p>

                    <button
                        onClick={handleRedirect}
                        style={{
                            backgroundColor: "#2563eb",
                            color: "#fff",
                            border: "none",
                            padding: "14px 32px",
                            fontSize: "16px",
                            fontWeight: "500",
                            borderRadius: "8px",
                            cursor: "pointer",
                            marginBottom: "30px",
                            boxShadow: "0 10px 20px rgba(37, 99, 235, 0.3)",
                            transition: "0.3s",
                        }}
                        onMouseOver={(e) => {
                            e.target.style.transform = "translateY(-3px)";
                            e.target.style.boxShadow =
                                "0 15px 25px rgba(37, 99, 235, 0.4)";
                        }}
                        onMouseOut={(e) => {
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow =
                                "0 10px 20px rgba(37, 99, 235, 0.3)";
                        }}
                    >
                        Go to Dashboard
                    </button>
                    <div
                        onClick={handleRedirect}
                        onKeyDown={(e) => e.key === "Enter" && handleRedirect()}
                        role="button"
                        tabIndex={0}
                        style={{cursor: "pointer"}}
                    >
                        <BrandLogo variant="page-not-found"/>
                    </div>
                </div>

                {/* Right Section (Illustration Style Box) */}
                <div
                    style={{
                        flex: "1",
                        minWidth: "300px",
                        textAlign: "center",
                        marginTop: "40px",
                    }}
                >
                    <div
                        style={{
                            background: "#ffffff",
                            padding: "40px",
                            borderRadius: "16px",
                            boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                            display: "inline-block",
                        }}
                    >
                        <div
                            style={{
                                fontSize: "80px",
                            }}
                        >
                            🔍
                        </div>
                        <p
                            style={{
                                marginTop: "15px",
                                color: "#6b7280",
                            }}
                        >
                            We couldn’t find what you’re looking for.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;